module.exports = __webpack_public_path__ + "static/img/success.0e8f351b.png";